@if (data) {
<div class="font-poppins text-gray-800">
  <h3 class="text-xl font-bold mb-1">List of Activities</h3>
  @for(activity of data.all_activities; track activity) {
  <ul class="list-disc pl-5">
    <li>
      <h3 class="text-lg mb-1">{{ activity.name }}</h3>
    </li>
  </ul>
  }
</div>
}